import React, { useState, useRef, useCallback, useEffect } from "react";
import {
  handleProductInfoAddtoCart,
  handleSetCartInfoStorageItems,
} from "../utilities/cartManager";
import { FaExclamationCircle } from "react-icons/fa";
import StarRatings from "react-star-ratings";
import {
  axiosGetProductReviews,
  AxiosPost_Nocatch,
} from "../utilities/axioscall";
import { AK } from "@/constants/index";
import { APPENUMS } from "@/constants/index";
import { CommentsView } from "./CommentsView";
import { FBPIXPush } from "@/services/fbConversionService";
import SizeChart from "@/components/themes/SizeChart";
import MediaGallery from "@/clicks/MediaGallery";
import RatingBox from "@/components/themes/RatingBox";

export const userCartInfoFetch = async (
  cartinfoData,
  setCartInfoData,
  push = false,
  fetch = false
) => {
  if (push) {
    AxiosPost_Nocatch(AK.USERCARTINFOFETCHPUSHAPI, cartinfoData, true)
      .then((res) => {
        if (res != typeof undefined && res.data != typeof undefined) {
        }
      })
      .catch((error) => {
        // console.log(error);
        return false;
      });
  } else if (fetch) {
    AxiosPost_Nocatch(AK.USERCARTINFOAPI, {}, true)
      .then((res) => {
        if (res != typeof undefined && res.data != typeof undefined) {
          setCartInfoData(res?.data?.cartinfo);
          handleSetCartInfoStorageItems(res?.data?.cartinfo);
          setCount({ ...count, count: count + 1 });
        }
      })
      .catch((error) => {
        // console.log(error);
        return false;
      });
  }
};

export const addtocartclicks = async (
  event,
  productinfo,
  sizeListData,
  setchooseSizeError,
  chooseCoupleSizeError,
  setchooseCoupleSizeError,
  pselectedMenSizes,
  psetselectedMenSizes,
  pselectedWomenSizes,
  psetselectedWomenSizes,
  pselectedCoupleSizes,
  psetselectedCoupleSizes,
  notify,
  notifyerror,
  setCount,
  count,
  pselectedSizes,
  pselectedWeights,
  weightListData,
  setchooseWeightError,
  gravingText,
  setgravingTextError,
  navigate,
  setCartInfoData,
  cartinfoData,
  gravingText1,
  setgravingText1,
  chooseGravingText1Error,
  setgravingText1Error,
  setProductInfoData
) => {
  try {
    if (productinfo?.addtocart) {
      navigate("/cart");
      return;
    }

    /* ---------- validation (unchanged) ---------- */
    if (productinfo?.variation?.includes("2")) {
      const sizeselected = sizeListData.some((s) => s.selected);
      if (!sizeselected) {
        setchooseSizeError(true);
        notifyerror("Please choose size.");
        setCount((c) => ({ ...c, count: c.count + 1 }));
        return;
      }
      setchooseSizeError(false);
    }

    if (productinfo?.variation?.includes("3")) {
      const weightselected = weightListData.some((w) => w.selected);
      if (!weightselected) {
        setchooseWeightError(true);
        notifyerror("Please choose weight.");
        setCount((c) => ({ ...c, count: c.count + 1 }));
        return;
      }
      setchooseWeightError(false);
    }

    if (productinfo?.variation?.includes("4") && !gravingText) {
      setgravingTextError(true);
      notifyerror("Please type your graving text.");
      return;
    }

    if (productinfo?.variation?.includes("8")) {
      if (!gravingText) { setgravingTextError(true); notifyerror("Please type your custom text 1."); return; }
      if (!gravingText1) { setgravingText1Error(true); notifyerror("Please type your custom text 2."); return; }
    }

    if (productinfo?.variation?.includes("7")) {
      if (!productinfo["selectedCoupleSizes"]?.Men[0]?.code) {
        setchooseSizeError(true);
        notifyerror("Please choose Men size.");
        return;
      }
      if (!productinfo["selectedCoupleSizes"]?.Women[0]?.code) {
        setchooseSizeError(true);
        notifyerror("Please choose Women size.");
        return;
      }
    }

    /* ---------- build cart item ---------- */
    const newproductinfo = {
      id: productinfo.id,
      esin: productinfo.esin,
      storeid: productinfo.storeid,
      products_id: productinfo.products_id,
      category_id: productinfo.category_id,
      colorcodes_id: productinfo.colorcodes_id,
      weight_id: productinfo.weight_id,
      size_id: productinfo.size_id,
      quantity: productinfo.quantity,
      mrp: productinfo.mrp,
      sp: productinfo.sp,
      name: productinfo.name,
      eng_name: productinfo.eng_name,
      seo_url: productinfo.seo_url,
      imageurl: productinfo.imageurl,
      images: productinfo.images,
      addtocart: true,
      cartquantity: 1,

      selectedGravingText: gravingText,
      selectedSizes: pselectedSizes,
      selectedSize: pselectedSizes,
      selectedMenSize: productinfo["selectedCoupleSizes"]?.Men[0],
      selectedWomenSize: productinfo["selectedCoupleSizes"]?.Women[0],
      selectedWeights: pselectedWeights,
      selectedWeight: pselectedWeights,

      "Custom Text": gravingText,
      "Custom Text1": gravingText1,
      "Couple Size": `Men: ${productinfo["selectedCoupleSizes"]?.Men[0]?.code} Women: ${productinfo["selectedCoupleSizes"]?.Women[0]?.code}`,
      Weight: pselectedWeights?.code,
      Size: pselectedSizes?.code,
      "Men Size": productinfo["selectedCoupleSizes"]?.Men[0]?.code,
      "Women Size": productinfo["selectedCoupleSizes"]?.Women[0]?.code,
    };

    const updatedCart = await handleProductInfoAddtoCart(
      newproductinfo,
      setCartInfoData,
      setCount,
      cartinfoData,
      count
    );

    setProductInfoData(prev => ({
      ...prev,
      addtocart: true,
      cartquantity: 1,
    }));
    userCartInfoFetch(updatedCart || cartinfoData, setCartInfoData, true, false);
    FBPIXPush(APPENUMS.EVENT_ENUMS.ADD_TO_CART, updatedCart || cartinfoData);
    notify();
    productinfo.addtocart = true;

  } catch (err) {
    console.error(err);
  }
};

export function variationsRender(
  variationsListData,
  productinfo,
  colorcodesListData,
  filterColor,
  onchangeProductColor,
  setCount,
  count,
  sizeListData,
  filterSize,
  pselectedSizes,
  psetselectedSizes,
  chooseCoupleSizeError,
  setchooseCoupleSizeError,
  pselectedMenSizes,
  psetselectedMenSizes,
  pselectedWomenSizes,
  psetselectedWomenSizes,
  pselectedCoupleSizes,
  psetselectedCoupleSizes,
  cartinfoData,
  setProductInfoData,
  setproductinfoselectedSize,
  productinfoselectedSize,
  chooseSizeError,
  weightListData,
  filterWeight,
  pselectedWeights,
  psetselectedWeights,
  setproductinfoselectedWeight,
  productinfoselectedWeight,
  onchangeProductWeight,
  chooseWeightError,
  setgravingText,
  chooseGravingTextError,
  isOpen,
  setIsOpen,
  isModalOpen,
  setIsModalOpen,
  toggleModal,
  imageSrc,
  gravingText1,
  setgravingText1,
  chooseGravingText1Error,
  setgravingText1Error
) {

  return (
    <div>
      {variationsListData?.map((variations) =>
        productinfo?.variation?.includes(variations?.id.toString()) &&
          variations?.id === 1 ? (
          <>
            <div className="" key={variations.id}>
              <div>
                <span className="colorName mb-2 block text-[14px]">
                  COLOR OPTIONS
                </span>

                <div className="flex flex-wrap items-center mb-2 gap-4">
                  {colorcodesListData.filter(filterColor).map((color) => (
                    <button
                      className={
                        color?.selected === true
                          ? " rounded-full border-2 border-primary p-1"
                          : " rounded-full border-2 border-gray-200 p-1"
                      }
                      onClick={async (event) => {
                        event.preventDefault();
                        let eventtarget = event.currentTarget;
                        if (eventtarget.readOnly) return;
                        eventtarget.readOnly = true;
                        colorcodesListData.map((colorsub) => {
                          colorsub["selected"] = false;
                        });
                        onchangeProductColor(color);
                        color["selected"] =
                          color?.selected === true ? false : true;
                        setCount({ ...count, count: count + 1 });
                        eventtarget.readOnly = false;
                      }}
                    >
                      <div
                        className="h-5 w-5 rounded-full border border-gray-100/5"
                        style={{ backgroundColor: color.code }}
                      />
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </>
        ) : productinfo?.variation?.includes(variations?.id.toString()) &&
          variations?.id === 2 ? (
          <>
            <hr className="mb-2" />

            <div className="mb-2 block" key={variations.id}>
              <div>
                <div>
                  <span className=" !mb-4 text-[14px]">
                    SELECT SIZE
                  </span>
                </div>
                <div className="flex justify-between">
                  <div className="flex items-end gap-2 flex-wrap" >
                    {sizeListData
                      .filter((size) => filterSize(size, null))
                      .sort((a, b) => a.sortorder - b.sortorder)
                      .map((size) => (
                        <button
                          key={size.code}
                          id={"sizecode" + size.code}
                          className={
                            size?.selected
                              ? " !w-[40px] !h-[40px] px-4 py-2 text-blue rounded-md border-2 border-primary bg-dash_menu_light hover:border-gray-900"
                              : " !w-[40px] !h-[40px px-4 py-2  rounded-md border hover:border-2 hover:border-gray-400"
                          }
                          onClick={(event) => {
                            event.preventDefault();
                            let eventtarget = event.currentTarget;
                            if (eventtarget.readOnly) return;
                            eventtarget.readOnly = true;
                            psetselectedSizes(size);
                            setCount({ ...count, count: count + 1 });
                            const updatedSizeListData = sizeListData.map(
                              (sizesub) => {
                                if (sizesub?.code === size?.code) {
                                  sizesub.selected = true;
                                } else {
                                  sizesub.selected = false;
                                }
                                return sizesub;
                              }
                            );
                            const selectedSizes = updatedSizeListData
                              ?.filter((sizesub) => sizesub.selected)
                              ?.map((sizesub) => sizesub?.code);
                            const productsaddtocart =
                              cartinfoData?.products?.filter(
                                (prod) =>
                                  prod?.selectedSize?.code === size?.code &&
                                  prod?.id === productinfo?.id
                              );
                            if (
                              productsaddtocart == null ||
                              productsaddtocart?.length === 0
                            ) {
                              productinfo["addtocart"] = false;
                            } else {
                              productinfo["addtocart"] = true;
                            }
                            setProductInfoData({
                              ...productinfo,
                              selectedSizes: selectedSizes,
                            });
                            setproductinfoselectedSize(productinfoselectedSize);
                            eventtarget.readOnly = false;
                          }}
                        >
                          {size.code}
                        </button>
                      ))}
                  </div>
                  <div>
                    <SizeChart />
                  </div>
                </div>
                <div hidden={!chooseSizeError}>
                  <p className="mb-2 flex text-red-500">
                    <span style={{ paddingTop: "3px" }}>
                      <FaExclamationCircle color="#e10e0e" />
                    </span>
                    &nbsp;&nbsp;Please choose size as per your fit.
                  </p>
                </div>
              </div>
            </div>
          </>
        ) : productinfo?.variation?.includes(variations?.id.toString()) &&
          variations?.id === 3 ? (
          <>
            <div className="block" key={variations.id}>
              <div>
                <span className=" mb-2 block">
                  SELECT WEIGHT
                </span>
                {/* Mobile */}
                <div className="flex items-end gap-2 flex-wrap" >

                  {weightListData
                    ?.filter(filterWeight)
                    .sort((a, b) => a.sortorder - b.sortorder)
                    .map((weight) => (
                      <button
                        key={weight.code}
                        id={"weightcode" + weight.code}
                        className={
                          weight?.selected === true
                            ? " text-primary px-2 py-2 rounded-md border-2 border-primary hover:border-gray-900"
                            : " px-2 py-2 rounded-md border hover:border-gray-400"
                        }
                        onClick={(event) => {
                          event.preventDefault();
                          const eventtarget = event.currentTarget;
                          if (eventtarget.readOnly) return;
                          eventtarget.readOnly = true;
                          const isInCart = cartinfoData?.products?.some((prod) => {
                            return (
                              prod.id === productinfo.id &&
                              prod.weight_id == weight.id &&
                              prod.colorcodes_id == productinfo.colorcodes_id &&
                              prod.selectedSize?.id == pselectedSizes?.id &&
                              prod.selectedMenSize?.id == pselectedMenSizes?.id &&
                              prod.selectedWomenSize?.id == pselectedWomenSizes?.id
                            );
                          });

                          if (isInCart && weight.selected) {
                            eventtarget.readOnly = false;
                            return;
                          }

                          psetselectedWeights(weight);
                          onchangeProductWeight(weight);

                          const updatedWeightListData = weightListData.map((weightsub) => {
                            weightsub.selected = weightsub.id === weight.id;
                            return weightsub;
                          });

                          setproductinfoselectedWeight(updatedWeightListData);

                          // Recheck cart status
                          const productsaddtocart = cartinfoData?.products?.some((prod) => {
                            return (
                              prod.id === productinfo.id &&
                              prod.weight_id == weight.id &&
                              prod.colorcodes_id == productinfo.colorcodes_id &&
                              prod.selectedSize?.id == pselectedSizes?.id &&
                              prod.selectedMenSize?.id == pselectedMenSizes?.id &&
                              prod.selectedWomenSize?.id == pselectedWomenSizes?.id
                            );
                          });

                          setProductInfoData((prev) => ({
                            ...prev,
                            addtocart: !!productsaddtocart,
                          }));

                          eventtarget.readOnly = false;
                        }}
                      >
                        {weight.code}
                      </button>
                    ))}
                </div>

                <div hidden={!chooseWeightError}>
                  <p className="mb-2 flex text-red-500">
                    <span style={{ paddingTop: "3px" }}>
                      <FaExclamationCircle color="#e10e0e" />
                    </span>
                    &nbsp;&nbsp;Please choose weight as per your fit.
                  </p>
                </div>
              </div>
            </div>
          </>
        ) : productinfo?.variation?.includes(variations?.id.toString()) &&
          variations?.id === 4 ? (
          <>
            <div className=" block" key={variations.id}>
              <div>
                {/* <span className="block mb-2 ">
                              Custom Text
                            </span> */}

                <input
                  className="w-full rounded-md border border-gray-200 py-2 px-2 focus:border-blue-300 focus:ring-blue-300"
                  onChange={(e) => setgravingText(e.target.value)}
                  type="text"
                  placeholder="ENTER YOUR TEXT"
                ></input>

                <div hidden={!chooseGravingTextError}>
                  <p className="mb-2 flex text-red-500">
                    <span style={{ paddingTop: "3px" }}>
                      <FaExclamationCircle color="#e10e0e" />
                    </span>
                    &nbsp;&nbsp;Please type your graving text.
                  </p>
                </div>
              </div>
            </div>
          </>
        ) : productinfo?.variation?.includes(variations?.id.toString()) &&
          variations?.id === 7 ? (
          <>
            <div className=" block" key={variations.id}>
              <div className="flex justify-between">
                <div>
                  <span className=" mb-2 block text-[14px]">
                    SELECT MULTIPLE SIZE
                  </span>
                  <span className=" mb-2 block text-[12px] text-gray_text">
                    MEN
                  </span>
                  <div className="flex items-end gap-2 flex-wrap" >
                    {sizeListData
                      .filter((size) => filterSize(size, "Men"))
                      .sort((a, b) => a.sortorder - b.sortorder)
                      .map((size) => (
                        <button
                          key={size.id}
                          id={"sizecode" + size.id}
                          className={
                            size?.id === pselectedMenSizes?.id
                              ? " px-4 py-2 text-blue  rounded-md text-[14px]  border-2 border-primary bg-dash_menu_light hover:border-gray-900"
                              : " px-4 py-2 rounded-md border text-[14px] !border-black hover:border-2 hover:border-gray-400"
                          }
                          onClick={(event) => {
                            event.preventDefault();
                            let eventtarget = event.currentTarget;
                            if (eventtarget.readOnly) return;
                            eventtarget.readOnly = true;
                            psetselectedMenSizes(size);
                            setCount({ ...count, count: count + 1 });
                            const updatedSizeListData = sizeListData
                              .filter((size) => filterSize(size, "Men"))
                              .map((sizesub) => {
                                if (sizesub?.id === size?.id) {
                                  sizesub.selected = true;
                                } else {
                                  sizesub.selected = false;
                                }
                                return sizesub;
                              });
                            const selectedSizes = updatedSizeListData
                              ?.filter((sizesub) => sizesub.selected)
                              ?.map((sizesub) => sizesub?.id);

                            const currentMenSizes = sizeListData.filter(
                              (selectedSize) =>
                                selectedSize.name === "Men" &&
                                selectedSize.selected === true
                            );
                            const currentWomenSizes = sizeListData.filter(
                              (selectedSize) =>
                                selectedSize.name === "Women" &&
                                selectedSize.selected === true
                            );
                            //` Men: ${productinfo["selectedCoupleSizes"]?.Men[0]?.code} Women: ${productinfo["selectedCoupleSizes"]?.Women[0]?.code}`
                            const productsaddtocart =
                              cartinfoData?.products?.filter((prod) => {
                                return (
                                  prod["selectedMenSize"]?.id === size?.id &&
                                  currentWomenSizes[0]?.id ===
                                  prod["selectedWomenSize"]?.id &&
                                  prod?.id === productinfo?.id
                                );
                              });
                            if (
                              productsaddtocart == null ||
                              productsaddtocart?.length === 0
                            )
                              productinfo["addtocart"] = false;
                            else productinfo["addtocart"] = true;

                            setProductInfoData({
                              ...productinfo,
                              selectedSizes: selectedSizes,
                              selectedCoupleSizes: {
                                Men: currentMenSizes,
                                Women: currentWomenSizes,
                              },
                            });
                            setproductinfoselectedSize(productinfoselectedSize);
                            // console.log(cartinfoData?.products);
                            eventtarget.readOnly = false;
                            // console.log(selectedSizes)
                            // console.log(productinfoselectedSize)
                          }}
                        >
                          {size.code}
                        </button>
                      ))}
                  </div>

                  <span className="  block text-[12px] text-gray_text">
                    WOMEN
                  </span>
                  <div className="flex items-end gap-2 flex-wrap" >
                    {sizeListData
                      .filter((size) => filterSize(size, "Women"))
                      .sort((a, b) => a.sortorder - b.sortorder)
                      .map((size) => (
                        <button
                          key={size.id}
                          id={"sizecode" + size.id}
                          className={
                            size?.id === pselectedWomenSizes?.id
                              ? " px-4 py-2 text-blue rounded-md  border-2 border-primary bg-dash_menu_light hover:border-gray-900"
                              : " px-4 py-2  rounded-md border hover:border-2 hover:border-gray-400"
                          }
                          onClick={(event) => {
                            event.preventDefault();
                            let eventtarget = event.currentTarget;
                            if (eventtarget.readOnly) return;
                            eventtarget.readOnly = true;
                            psetselectedWomenSizes(size);
                            setCount({ ...count, count: count + 1 });
                            const updatedSizeListData = sizeListData
                              .filter((size) => filterSize(size, "Women"))
                              .map((sizesub) => {
                                if (sizesub?.id === size?.id) {
                                  sizesub.selected = true;
                                } else {
                                  sizesub.selected = false;
                                }
                                return sizesub;
                              });

                            const currentMenSizes = sizeListData.filter(
                              (selectedSize) =>
                                selectedSize.name === "Men" &&
                                selectedSize.selected === true
                            );
                            const currentWomenSizes = sizeListData.filter(
                              (selectedSize) =>
                                selectedSize.name === "Women" &&
                                selectedSize.selected === true
                            );

                            const selectedSizes = updatedSizeListData
                              ?.filter((sizesub) => sizesub.selected)
                              ?.map((sizesub) => sizesub?.id);
                            const productsaddtocart =
                              cartinfoData?.products?.filter((prod) => {
                                return (
                                  prod["selectedWomenSize"]?.id === size?.id &&
                                  currentMenSizes[0]?.id ===
                                  prod["selectedMenSize"]?.id &&
                                  prod?.id === productinfo?.id
                                );
                              });
                            if (
                              productsaddtocart == null ||
                              productsaddtocart?.length === 0
                            )
                              productinfo["addtocart"] = false;
                            else productinfo["addtocart"] = true;

                            // setProductInfoData({
                            //   ...productinfo,
                            //   selectedSizes: selectedSizes,
                            // });
                            setProductInfoData({
                              ...productinfo,
                              selectedSizes: selectedSizes,
                              selectedCoupleSizes: {
                                Men: currentMenSizes,
                                Women: currentWomenSizes,
                              },
                            });
                            setproductinfoselectedSize(productinfoselectedSize);
                            // console.log(cartinfoData?.products);
                            eventtarget.readOnly = false;
                            // console.log(selectedSizes)
                            // console.log(productinfoselectedSize)
                          }}
                        >
                          {size.code}
                        </button>
                      ))}
                  </div>

                  <div hidden={!chooseSizeError}>
                    <p className="mb-2 flex text-red-500">
                      <span style={{ paddingTop: "3px" }}>
                        <FaExclamationCircle color="#e10e0e" />
                      </span>
                      &nbsp;&nbsp;Please choose couple size as per your fit.
                    </p>
                  </div>
                </div>
                <div>
                  <SizeChart />
                </div>
              </div>
            </div>
          </>
        ) : productinfo?.variation?.includes(variations?.id.toString()) &&
          variations?.id === 8 ? (
          <>
            <div className="mb-2 block" key={variations.id}>
              <div>
                {/* <span className="block mb-2 ">
                            Custom Text
                          </span> */}

                <input
                  class="mb-4 w-full rounded-md border border-gray-200 px-12 py-2 focus:border-blue-300 focus:ring-blue-300"
                  onChange={(e) => setgravingText(e.target.value)}
                  type="text"
                  placeholder="ENTER YOUR TEXT"
                ></input>

                <input
                  class="mb-4 w-full rounded-md border border-gray-200 px-12 py-2 focus:border-blue-300 focus:ring-blue-300"
                  onChange={(e) => setgravingText1(e.target.value)}
                  type="text"
                  placeholder="ENTER YOUR TEXT"
                ></input>

                <div hidden={!chooseGravingTextError}>
                  <p className="mb-2 flex text-red-500">
                    <span style={{ paddingTop: "3px" }}>
                      <FaExclamationCircle color="#e10e0e" />
                    </span>
                    &nbsp;&nbsp;Please type your custom text 1.
                  </p>
                </div>
                <div hidden={!chooseGravingText1Error}>
                  <p className="mb-2 flex text-red-500">
                    <span style={{ paddingTop: "3px" }}>
                      <FaExclamationCircle color="#e10e0e" />
                    </span>
                    &nbsp;&nbsp;Please type your custom text 2.
                  </p>
                </div>
              </div>
            </div>
          </>
        ) : (
          <></>
        )
      )}
    </div>
  );
}



export function productreviewRender(
  productreviewList,
  setwritereview,
  assets,
  productaveragerating,
  productinfo,
  isModalOpen,
  setIsModalOpen,
  toggleModal
) {
  console.log("productaverageratingdata", productaveragerating);

  const storeCode = process.env.NEXT_PUBLIC_STORE_CODE;
  const mainurl = `https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/${storeCode}`;

  return (
    <div className="">
      <div className="">
        <div className="text-category_name">
          <div className="flex items-center gap-x-1 mb-[16px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-thumbs-up-icon lucide-thumbs-up"
            >
              <path d="M7 10v12" />
              <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
            </svg>
            <p className="text-[11px]">
              {Math.round(
                (productreviewList.filter((prod) => prod.rating >= 4).length /
                  productreviewList.length) *
                100
              ) || 0}
              % of verified buyers recommend this brand
            </p>
          </div>

          <div className="flex items-center my-[16px]">
            <div className="w-1/2 flex flex-col justify-center items-center">
              <div className="flex flex-col justify-center items-center space-y-[10px] bg-white shadow-md rounded-[8px] py-[20px] px-[30px] w-fit">
                <h1 className="text-7xl font-bold">
                  {!isNaN(parseFloat(productaveragerating))
                    ? parseFloat(productaveragerating).toFixed(1)
                    : 0}
                </h1>
                <p>({productreviewList.length} ratings)</p>
                <div className="flex gap-1">
                  <StarRatings
                    rating={
                      productaveragerating
                        ? parseFloat(productaveragerating)
                        : 0
                    }
                    starRatedColor="orange"
                    starDimension="16px"
                    starSpacing="2px"
                    numberOfStars={5}
                  />
                </div>
                {/* <button
                  className="border border-[#d1d1d1] px-4 font-semibold py-2 text-[#207BB4]"
                  onClick={(event) => {
                    event.preventDefault();
                    setwritereview(true);
                    // setTimeout(() => {
                    //   window.scrollTo({ top: 0, behavior: "smooth" });
                    // }, 0);
                  }}
                >
                  RATE
                </button> */}

                <RatingBox
                  product={{
                    ...productinfo,
                    imageurl: productinfo.images,
                  }}
                // assets={assets}
                // onSubmitRating={handleAddReview}
                />
              </div>
            </div>
            <div className="w-1/2 px-[4px]">
              <div className="flex flex-col gap-y-[16px]">
                {[5, 4, 3, 2, 1].map((rating) => (
                  <div
                    key={rating}
                    className="flex items-center justify-between gap-x-1"
                  >
                    <p className="text-[12px] w-[10px]">{rating}</p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-star-icon lucide-star"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" /></svg>
                    <div className="rang w-full h-full rounded-full bg-[#d2d2d2]">
                      <div
                        className="h-[3px] p-[2px] rounded-full bg-primary"
                        style={{
                          width: `${(productreviewList.filter(
                            (prod) =>
                              prod.rating >= rating &&
                              prod.rating < rating + 1
                          ).length /
                            productreviewList.length) *
                            100
                            }%`,
                        }}
                      ></div>
                    </div>
                    <p className="text-[12px]">
                      {
                        productreviewList.filter(
                          (prod) =>
                            prod.rating >= rating && prod.rating < rating + 1
                        ).length
                      }
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div>
            {productreviewList.length > 0 && (
              <div className="mt-4 space-y-4">
                {productreviewList.slice(0, 2).map((prod, index) => (
                  <div
                    key={index}
                    className={`py-4 ${productreviewList.length > 1 &&
                      index !== productreviewList.slice(0, 2).length - 1
                      ? "border-b-2 border-border_bg"
                      : ""
                      }`}
                  >
                    <div className="flex space-x-4">
                      <div className="rounded-full border-2 border-primary_hover !h-fit">
                        <img
                          className="w-[40px] h-[40px] rounded-full object-cover"
                          src="https://vilva-backup.blr1.digitaloceanspaces.com/vilvabusiness/common%20files/user_img.jpg"
                          alt="User Avatar"
                        />
                      </div>
                      <div className="space-y-2 w-full">
                        <div className="space-x-4 flex items-center">
                          <p className="text-black text-[14px] font-semibold">
                            {prod.username}
                          </p>
                          <div className="bg-dash_menu_light px-2 py-1 space-x-1 rounded-[4px] flex items-center w-fit">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-map-pin text-primary"
                            >
                              <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                              <circle cx="12" cy="10" r="3" />
                            </svg>
                            <p className="text-primary text-[14px] font-medium">
                              {prod.user_city}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          <div className="flex gap-1">
                            {[1, 2, 3, 4, 5].map((star) => (
                              <svg
                                key={star}
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className={`lucide lucide-star-icon lucide-star w-5 h-5 ${prod.rating >= star
                                  ? "fill-yellow-400 stroke-yellow-400"
                                  : "fill-none stroke-gray_text"
                                  }`}
                              >
                                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                              </svg>
                            ))}
                          </div>
                        </div>
                        <p>Feedback: {prod.comment}</p>
                        <p className="text-xs text-gray_text">
                          {prod.created_at}
                        </p>
                        <MediaGallery prod={prod} mainurl={mainurl} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {productreviewList.length > 2 && (
            <div className="my-2">
              <p
                className="text-primary text-center font-montserrat text-[16px] font-semibold leading-[19.2px] underline underline-offset-[3.28px] decoration-[1.92px] cursor-pointer"
                onClick={() => {
                  toggleModal();
                  setIsModalOpen(true); // Ensure modal state is set to open
                }}
              >
                View all Comments
              </p>
            </div>
          )}

          {isModalOpen && (
            <div className="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-50 h-[60vh]">
              <div className="bg-white h-[70vh] w-full overflow-auto   rounded-l-[16px] transform transition-transform duration-300 ease-in-out translate-x-0">
                <CommentsView
                  productreviewList={productreviewList}
                  assets={assets}
                  productaveragerating={productaveragerating}
                  productinfo={productinfo}
                  setwritereview={setwritereview}
                  onClose={() => {
                    toggleModal();
                    setIsModalOpen(false); // Ensure modal state is set to closed
                  }}
                  toggleModal={toggleModal}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

